import * as TypeGraphQL from "type-graphql";
export var ActionType;
(function (ActionType) {
    ActionType["BUY"] = "BUY";
    ActionType["BUY_OPTION"] = "BUY_OPTION";
    ActionType["EXERCISE_OPTION"] = "EXERCISE_OPTION";
    ActionType["SELL"] = "SELL";
    ActionType["CANCEL"] = "CANCEL";
    ActionType["ADJUST"] = "ADJUST";
    ActionType["HEDGE"] = "HEDGE";
})(ActionType || (ActionType = {}));
TypeGraphQL.registerEnumType(ActionType, {
    name: "ActionType",
    description: undefined,
});
//# sourceMappingURL=ActionType.js.map